export const FETCH_CATEGORIES_LIST = 'FETCH_CATEGORIES_LIST';
export const SELECT_CATEGORY = 'SELECT_CATEGORY';
export const FETCH_TAGS_LIST_FOR_CATEGORY = 'FETCH_TAGS_FOR_CATEGORY_LIST';
export const FETCH_TAGS_LIST_FOR_CATEGORY_SUCCESS = 'FETCH_TAGS_LIST_FOR_CATEGORY_SUCCESS';
export const FETCH_TAGS_LIST_FOR_FAILURE = 'FETCH_TAGS_LIST_FOR_FAILURE';
export const FETCH_SUB_TAGS_LIST_FOR_CATEGORY = 'FETCH_SUB_TAGS_FOR_CATEGORY_LIST';
export const FETCH_SUB_TAGS_LIST_FOR_CATEGORY_SUCCESS = 'FETCH_SUB_TAGS_LIST_FOR_CATEGORY_SUCCESS';
export const FETCH_SUB_TAGS_LIST_FOR_FAILURE = 'FETCH_SUB_TAGS_LIST_FOR_FAILURE';
export const SAVING_CATEGORY = 'SAVING_CATEGORY';
export const SAVING_CATEGORY_SUCCESS = 'SAVING_CATEGORY_SUCCESS';
export const SAVING_CATEGORY_FAILURE = 'SAVING_CATEGORY_FAILURE';
export const SAVING_TAG = 'SAVING_TAG';
export const SAVING_TAG_SUCCESS = 'SAVING_TAG_SUCCESS';
export const SAVING_TAG_FAILURE = 'SAVING_TAG_FAILURE';

export const UPLOAD_TAGS = 'UPLOAD_TAGS';
export const UPLOAD_TAGS_SUCCESS = 'UPLOAD_TAGS_SUCCESS';
export const UPLOAD_TAGS_FAILURE = 'UPLOAD_TAGS_FAILURE';

export const IMPORT_TAGS = 'IMPORT_TAGS';
export const IMPORT_TAGS_SUCCESS = 'IMPORT_TAGS_SUCCESS';
export const IMPORT_TAGS_FAILURE = 'IMPORT_TAGS_FAILURE';

export const DELETE_TAG = 'DELETE_TAG';
export const DELETE_TAG_SUCCESS = 'DELETE_TAG_SUCCESS';
export const DELETE_TAG_FAILURE = 'DELETE_TAG_FAILURE';

export const CLEAR_IMPORTED_TAGS_ENTITIES = 'CLEAR_IMPORTED_TAGS_ENTITIES';

